import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/blast-off.png'
import _imports_1 from '@/assets/images/shape-20.png'
import _imports_2 from '@/assets/images/shape-21.png'


const _hoisted_1 = { class: "page-banner-area bg-secondary" }
const _hoisted_2 = { class: "container mw-1720" }
const _hoisted_3 = { class: "page-banner-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 list-unstyled bredcrounbs" }
const _hoisted_5 = { class: "container mw-1356" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("الرئيسية", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("li", null, [
            _createElementVNode("span", null, "المتجر")
          ], -1))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, " اكتشف، اختر، وارتقِ بتجربتك الترفيهية الرقمية: غص في عالم مليء بالخيارات اللامحدودة مع متجرنا الخاص. ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "blast-off-bg bg-img rounded-2",
        style: _normalizeStyle({
          backgroundImage: `url(${require('@/assets/images/blast-off-bg.jpg')})`,
        })
      }, [...(_cache[3] || (_cache[3] = [
        _createStaticVNode("<div class=\"row align-items-center\" data-cues=\"zoomOut\"><div class=\"col-lg-6 col-md-6\"><div class=\"blast-off-content mw-100\"><h2 class=\"text-golden\">انطلق الآن مع أقوى عروض السيرفرات الذكية</h2><p> مع سيرفرات IPTV فائقة الثبات والسرعة، اتصل، شاهد، واستمتع بأقوى المباريات والأفلام بجودة لم تشهدها من قبل. </p></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"blast-off-img\"><img src=\"" + _imports_0 + "\" alt=\"\"></div></div></div>", 1)
      ]))], 4)
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape-21 shape",
      alt: "shape"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_2,
      class: "shape-22 shape",
      alt: "shape"
    }, null, -1))
  ]))
}